import { render, staticRenderFns } from "./FormBasic.vue?vue&type=template&id=69a504be&"
import script from "./FormBasic.vue?vue&type=script&lang=js&"
export * from "./FormBasic.vue?vue&type=script&lang=js&"
import style0 from "./FormBasic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports